// 马来语
export default {
  'SLModal.default.okText': 'Selesai',
  'SLModal.default.cacelText': 'Batal',
  'SLModal.info.okText': 'Saya faham',
  'SLPopconfirm.cancelText': 'Batal',
  'SLPopconfirm.okText': 'Ok',
  'SLModal.danger.okText': 'Padam',
  'SLUpload.default.image.addImage': 'Tambah imej',
  'SLUpload.default.image.restImages': 'Lihat baki {{len}} gambar',
  'SLUpload.default.image.loading': 'Memuat naik',
  'SLUpload.default.image.fail': 'Muat naik gagal, sila cuba lagi',
  'SLUpload.default.image.delete.title': 'Adakah hendak padam?',
  'SLUpload.default.image.delete.content': 'Tidak dapat dipulihkan selepas dipadamkan.',
  'SLUpload.ALTFormModal.placeholder': 'Sila masukkan atribut ALT gambar',
  'SLUpload.ALTFormModal.tip': 'Edit atribut ALT gambar dap bantu mengoptimumkan enjin carian (SEO) dan pengalaman cacat penglihatan',
  'SLUpload.ALTFormModal.title': 'Edit atribut ALT gambar',
  'SLUpload.ALTFormModal.length': 'Tidak boleh melebihi {{max}} aksara',
  'SLUpload.uploadfile.fail': 'Gagal muat naik',
  'SLUpload.uploadfile.fail1': 'Ralat format fail',
  'SLUpload.uploadfile.sucess': 'Berjaya muat naik',
  'SLUpload.uploadfile.text1': 'Memuat naik dokumen',
  'SLUpload.uploadfile.text2': '',
  'SLUpload.uploadfile.progress': 'Memuat naik…',
  'SLUpload.dragUploading': 'Lepaskan tetikus memuat naik',
  'SLUpload.default.image.description': 'Saiz yang dicadangkan 256 x 116',
  'SLUpload.default.image.fail.title': '{{fileName}} muat naik gagal',
  'SLUpload.default.image.fail.desc1': 'Saiz tidak boleh melebihi {{max}}MB',
  'SLUpload.default.image.fail.desc2': 'Nama muat naik tidak boleh melebihi {{max}} aksara',
  'SLUpload.default.image.fail.desc3': 'Dokumen melebihi resolusi maksimum {{limitPx}}MP. Sila kurangkan resolusi dan cuba lagi',
  'SLUpload.default.image.fail.desc4': 'Minta maaf!Hanya boleh muat naik gambar tidak lebih daripada {{maxNum}}',
  'SLUpload.uploadField.errorMsg4': 'Gagal memuat naik gambar',
  'SLUpload.uploadField.upload': 'Muat naik gambar',
  'SLUpload.SLImage.preview.closeText': 'Tutup'
};